// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2EBoi","infoBtn":"quickbooks_infoBtn__1tZGW","formBox":"quickbooks_formBox__3MGme","formFooter":"quickbooks_formFooter__3Jiwo"};